import '@naturehouse/design-system/components/atoms/date-field/DateField';
import '@naturehouse/design-system/components/molecules/calendar-week-days/CalendarWeekDays';
import '../../ui/web-components/searchBar/DestinationSearch';
import '../../ui/web-components/searchBar/SearchBar';
import '../calendar/webComponents/CalendarInput';
import '../calendar/webComponents/DatePickerCalendar';
import NavigationHelper from './NavigationHelper';
import '../../../css/views/homepage.pcss';
import RecentlyViewedHousesTracking from './RecentlyViewedHousesTracking';

export default class HomepageModule {
    public initialize(): void {
        NavigationHelper.getInstance();

        const houseCards: HTMLElement[] = RecentlyViewedHousesTracking.getHouseCards();

        if (houseCards.length === 0) {
            return;
        }

        RecentlyViewedHousesTracking.trackViewListItem();

        for (const [index, houseCard] of houseCards.entries()) {
            houseCard.querySelectorAll('a').forEach((anchor): void => {
                anchor.addEventListener('click', (): void => {
                    RecentlyViewedHousesTracking.trackSelectItem(houseCard, index);
                });
            });
        }
    }
}

(function homepageModuleInit(): void {
    const homepageModule: HomepageModule = new HomepageModule();
    homepageModule.initialize();
})();
